import axios from 'axios'
// import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken, getAuthorization, getSubdomain, getApplicationType } from '@/utils/auth'

// create an axios instance
const service = axios.create({
  baseURL: process.env.API_POINT_URL, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 50000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  async config => {
    switch (getApplicationType()) {
      case 'OFFLINE':
        config.baseURL = await process.env.API_POINT_URL_OFFLINE
        break;
    }
    // do something before request is sent
    // config.headers['Authorization'] = getAuthorization()
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded'

    // config.headers['Content-Type'] = 'application/form-data'
    // console.log("store.state.monitoring.switchAccoun",store.state.monitoring.switchAccount)

    if (getToken() != null) {
      config.headers['Authorization'] = 'Bearer ' + getToken()
    } else {
      config.headers['Authorization'] = getAuthorization()
    }


    // if (store.state.monitoring.switchAccount == 1) {
    // config.headers['Subdomain'] = store.state.monitoring.multiAccountSubdomain
    // if (store.state.monitoring.multiAccountToken != "") {
    // config.headers['Token'] = store.state.monitoring.multiAccountToken
    // }
    // } else {
    // config.headers['Subdomain'] =getSubdomain()
    // if (store.getters.token) {
    // config.headers['Token'] = getToken()
    // }
    // }

    return config
  },
  error => {
    // do something with request error
    console.log('errorx', error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    // const res = response
    // if the custom code is not 20000, it is judged as an error.
    // console.log('responseaa', response)
    // console.log('rescode', res.status)
    if (res.status !== 200) {
      var errorMsg = res.data

      // console.log(errorMsg)
      // Message({
      //   message: res.msg || 'Error',
      //   type: 'error',
      //   duration: 5 * 1000
      // })

      store.dispatch('onsen/updateToastVisible', { shouldOpen: true, msg: errorMsg })
      setTimeout(function () { store.dispatch('onsen/updateToastVisible', { shouldOpen: false, msg: '' }) }, 2000)

      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      // if (res.status === 50008 || res.status === 50012 || res.status === 50014) {
      //   // to re-login
      //   MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
      //     confirmButtonText: 'Re-Login',
      //     cancelButtonText: 'Cancel',
      //     type: 'warning'
      //   }).then(() => {
      //     store.dispatch('user/resetToken').then(() => {
      //       location.reload()
      //     })
      //   })
      // }
      return Promise.reject(new Error(res.msg || 'Error'))
    } else {
      return res
    }
  },
  error => {
    let errorMsg = ''
    if (!error.response) {
      // network error
      errorMsg = 'Network Error: Unable to access the network';
      console.log(error)
    } else {
      errorMsg = error.response.data.msg.replace(/<br\s*\/?>/gi, '\n');

    }
    store.dispatch('onsen/updateToastVisible', { shouldOpen: true, msg: errorMsg })
    setTimeout(function () { store.dispatch('onsen/updateToastVisible', { shouldOpen: false, msg: '' }) }, 2000)

    return Promise.reject(error)
  }
)
// if(getApplicationType()=="OFFLINE"){
console.log("xxxx", getApplicationType())
// }
export default service



// WEBPACK FOOTER //
// ./src/utils/request.js